// src/pages/Blog.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import blogData from '../data/blogData';
import '../styles/Blog.css';

const Blog = () => {
  return (
    <div className="blog">
      <SEO
        title="Blog | Bularis Tech"
        description="Legacy Bularis Tech blog content."
        path="/blog"
        noIndex
      />
      <div className="blog-header">
        <h1>Blog</h1>
        <p>Stay updated with our latest posts and articles.</p>
      </div>
      <div className="blog-posts">
        {blogData.map((post) => (
          <div key={post.id} className="blog-post">
            <h2>{post.title}</h2>
            <p>{post.description}</p>
            <Link to={`/blog/${post.id}`}>Read More →</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
